import { Outlet } from 'react-router-dom';
import { Nav } from './Nav';
import { Tabs } from './Tabs';

export const HomePage = () => {
  return (
    <>
      <Nav />
      <section className='page-hero'>
        <h1>Find Your Next Bandmate</h1>
        <p>Discover musicians and bands looking for the right collaboration.</p>
      </section>
      <Tabs />
      <Outlet />
    </>
  );
};
